import React, { useEffect, useState } from "react";
import { setKey, setStringifiedKey } from "../store/actions";
import { connect } from "react-redux";
import utils from '../utils/utils'
import keys from "../store/keys";
import CheckoutItem from "./CheckoutItem";
import conversionService from "../services/conversion";

function Checkout({ session, setKey, ...props }) {
	const [items, setItems] = useState([]);

	useEffect(() => {
		let t = JSON.parse(localStorage.getItem(keys.cart)) || [];
		setItems(t);
	}, [session.counter]);


	const convertCartPrices = async () => {
		let t = JSON.parse(localStorage.getItem(keys.cart)) || [];
		
		if(t.length === 0) return;
		if(!session.selectedRegion) return;
		
		setKey(keys.isLoading, true);
		let previousCurrency = t[0].currency;
		let newCurrency = session.selectedRegion.currency;
		for (let i = 0; i < t.length; i++) {
			t[i].currency = newCurrency;
			let response = await conversionService.convert({ from: previousCurrency, to: newCurrency, amount: t[i].selectedVariant.price })
			t[i].selectedVariant.price = response.data.value;

			let variants = t[i].product.variants;
			for (let j = 0; j < variants.length; j++) {
				let response = await conversionService.convert({ from: previousCurrency, to: newCurrency, amount: variants[j].price })
				variants[j].price = response.data.value;
			}
			t[i].product.variants = variants;
		}

		setItems([]);
		setStringifiedKey(keys.cart, t);
		setItems(t);
		setKey(keys.isLoading, false);
	}

	useEffect(() => {
		convertCartPrices();
	}, [session.selectedRegion]);

	const render = () => {
		if (!items || items.length === 0) {
			return <tr><td className="mt-10" colSpan={4}>No items found in cart.</td></tr>
		}

		return items.map(k => <CheckoutItem data={k} key={k.id} />);
	}

	return (
		<>
			<p className="cart-title">Shopping Basket</p>
			<hr />
			<table className="cart-items table table-responsive table-borderless">
				<thead>
					<tr>
						<th colSpan={2} className="text-center">Item</th>
						<th>Item Price</th>
						<th>Quantity</th>
						<th className="text-end">Total Price</th>
					</tr>
				</thead>
				<tbody>
					{render()}
				</tbody>
			</table>
		</>
	);
}

const mapStateToProps = (store) => ({ session: store.session });
const mapDispatchToProps = (dispatch) => ({
	setKey: (key, value) => dispatch(setKey(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Checkout);
